import { Box, Divider } from '@mui/material';
import { FC } from 'react';

import { AbgDividerProps } from './types';

export const AbgDivider: FC<AbgDividerProps> = ({
  type,
  thickness,
  color,
  aemAttributes = {},
}) => {
  return (
    <Box
      {...aemAttributes}
      data-testid="divider"
      data-aue-type="component"
      sx={{ width: '100%' }}
    >
      <Divider
        orientation={type}
        flexItem={type === 'vertical'}
        sx={{
          ...(type === 'horizontal'
            ? {
                height: `${thickness}px`,
                borderBottomWidth: `${thickness}px`,
                borderBottomColor: color,
              }
            : {
                width: `${thickness}px`,
                borderRightWidth: `${thickness}px`,
                borderRightColor: color,
              }),
        }}
      />
    </Box>
  );
};
